// extracted by mini-css-extract-plugin
export default {"cls1":"WinBackPing-cls1__fbd63c93dd438f9660dc","cls2":"WinBackPing-cls2___f32fac45dc1578f79ae WinBackPing-cls1__fbd63c93dd438f9660dc"};